export default __webpack_public_path__ + "static/IllustrationPoseComparison-b39fa53a23ddce347767ad9fdbf38c1a.png";